import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { CustomReportGroup } from '../../../../redux/context/customReports/types'
import { contextCompanyIdSelector } from '../../../../redux/context/company/selectors'
import { createCustomReportGroup } from '../../service/customReportGroupService'
import customReportQueryKeys from '../customReportQueryKeys'

export const useCreateCustomReportGroup = () => {
  const { t } = useTranslation()
  const companyId = useSelector(contextCompanyIdSelector)!
  const { notification } = App.useApp()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: Partial<CustomReportGroup>) => createCustomReportGroup(data, companyId),
    onSuccess: () => {
      notification.success({
        message: t('messages:createSuccess', 'Request sent')
      })
      return queryClient.invalidateQueries({
        queryKey: customReportQueryKeys.groups(companyId)
      })
    }
  })
}
